<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="2"
                    :total="3" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-6",
            currentTrivia: 5,
            questions: {
                question: {
                    "title": "Which of the following is NOT an indicator of ORC activity?",
                    "answers": [
                        {"key": "A", "answer": "Subject took large quantities of the same merchandise"},
                        {"key": "B", "answer": "Shoplifter used props"},
                        {"key": "C", "answer": "Shoplifter takes items for personal gain or consumption"},
                        {"key": "D", "answer": "Researching loss prevention"}
                    ],
                    "correctAnswer": ["C"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
